import React from 'react';
import { Helmet } from 'react-helmet-async';

const ResourceOptimization = () => {
  return (
    <Helmet>
      {/* CRA emits hashed bundle names and injects its own tags, so preloading
          fixed paths here only ever fetched 404s. */}
      {/* DNS prefetch for external resources */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      
      {/* Preconnect for critical third-party resources */}
      <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      <script>
        {`
          // Resource loading optimization
          (function() {
            // A "load critical CSS" step used to inject /static/css/main.css here.
            // CRA emits hashed filenames and links the real stylesheet itself, so
            // that path never existed and 404'd on every page view.

            // Defer non-critical resources
            window.addEventListener('load', function() {
              // Lazy load images
              const lazyImages = document.querySelectorAll('img[data-src]');
              if ('IntersectionObserver' in window) {
                const imageObserver = new IntersectionObserver((entries, observer) => {
                  entries.forEach(entry => {
                    if (entry.isIntersecting) {
                      const img = entry.target;
                      img.src = img.dataset.src;
                      img.classList.remove('lazy');
                      imageObserver.unobserve(img);
                    }
                  });
                });
                
                lazyImages.forEach(img => imageObserver.observe(img));
              }
            });

            // A "combine small CSS files" step used to live here. It fetched every
            // stylesheet link, injected any response under 2KB as an inline style
            // and removed the original link - without checking response.ok or the
            // content type. When a request 404'd it injected the error page HTML
            // as CSS, which parsed into junk rules and collapsed page layouts.
            // Removed: the saving never justified the risk.
          })();
        `}
      </script>
      
      <style>
        {`
          /* Optimize render performance */
          * {
            box-sizing: border-box;
          }
          
          img.lazy {
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          img.lazy.loaded {
            opacity: 1;
          }
          
          /* Reduce layout shifts */
          img {
            width: auto;
            height: auto;
            max-width: 100%;
          }
          
          /* Font display optimization */
          @font-face {
            font-family: system-ui;
            font-display: swap;
          }
        `}
      </style>
    </Helmet>
  );
};

export default ResourceOptimization;